/**
 * @file index.tsx
 * @module app/modules/contact-inquiries
 * @description Defines routing and page metadata for the Contact Inquiries module.
 * Redirects the module root to the inquiries page and renders its breadcrumb title.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../_admin/layout/core";

import ContactInquiries from "./contact-inquiries";
const contactInquiriesBreadCrumbs: Array<PageLink> = [
  {
    title: "Contact Inquiries",
    path: "/contact-inquiries",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];
const index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path="*" element={<Navigate to="/error/404" />} />

        <Route index element={<Navigate to="/contact-inquiries" />} />

        <Route
          path="inquiries"
          element={
            <>
              <PageTitle>
                Contact Inquiries
              </PageTitle>
              <ContactInquiries />
            </>
          }
        />
      </Route>
    </Routes>
  );
};

export default index;
